import React from "react";
import Tokens from "../../../store/tokens";

import Link from "./Link";

interface Props {
  inSideDrawer?: boolean;
  onClick?: () => void;
}

const Links: React.FC<Props> = (props) => {
  const { accountId } = Tokens.useContainer();
  return (
    <div className="flex flex-col md:flex-row" onClick={props.onClick}>
      <Link to="/movies" inSideDrawer={props.inSideDrawer}>
        Movies
      </Link>
      {accountId && (
        <Link to="/favorites" inSideDrawer={props.inSideDrawer}>
          My Favorite
        </Link>
      )}
    </div>
  );
};

export default Links;
